import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  ref: "printZone",
  class: "phasesWrapper"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_PhaseComponent = _resolveComponent("PhaseComponent")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_container, { class: "fill-height" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_responsive, {
          class: "align-top mx-auto",
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      label: "Race",
                      modelValue: _ctx.selectedRace,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRace) = $event)),
                      items: _ctx.phases.races,
                      "item-title": 'titre',
                      "item-value": 'id'
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      label: "Culture",
                      modelValue: _ctx.selectedCulture,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCulture) = $event)),
                      items: _ctx.phases.cultures,
                      "item-title": 'titre',
                      "item-value": 'id'
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      label: "Caste",
                      modelValue: _ctx.selectedCaste,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCaste) = $event)),
                      items: _ctx.phases.castes,
                      "item-title": 'titre',
                      "item-value": 'id'
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      label: "Carriere",
                      modelValue: _ctx.selectedCarriere,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCarriere) = $event)),
                      items: _ctx.phases.carrieres,
                      "item-title": 'titre',
                      "item-value": 'id'
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      name: "search",
                      modelValue: _ctx.searchTerm,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchTerm) = $event)),
                      onKeyup: _ctx.findPhases,
                      placeholder: "Entrez un mot à rechercher"
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { onClick: _ctx.deleteTerm }, {
                      default: _withCtx(() => [
                        _createTextVNode("Effacer")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { onClick: _ctx.generatePDF }, {
                      default: _withCtx(() => [
                        _createTextVNode("Générer le PDF")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchPhases, (phase, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "phasesListWrapper",
                        key: key
                      }, [
                        _createVNode(_component_PhaseComponent, { phase: phase }, null, 8, ["phase"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPhases, (phase, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "phasesWrapper2",
          key: key
        }, [
          (phase.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_PhaseComponent, { phase: phase }, null, 8, ["phase"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512)
  ]))
}